export default "__VITE_ASSET__1S3m8a$y__"